import { addAppErrorMessage, addAppInfoMessage } from 'modules/alerts/state';
import type { ApiExceptionMessage } from 'modules/api/utils';
import { useAppDispatch } from 'store';

import { ErrorCode } from './ErrorCode';

type Props = ApiExceptionMessage;

export const ErrorCodeContainer = ({ ...apiExceptionMessage }: Props) => {
  const dispatch = useAppDispatch();
  const scope = apiExceptionMessage.stackTrace ? 'stack trace' : 'code';

  const handleCopySuccess = () => {
    dispatch(addAppInfoMessage(`Error ${scope} copied to clipboard`));
  };
  const handleCopyError = () => {
    dispatch(addAppErrorMessage(`Could not copy error ${scope} to clipboard. Please try again.`));
  };

  return (
    <ErrorCode scope={scope} onCopySuccess={handleCopySuccess} onCopyError={handleCopyError} {...apiExceptionMessage} />
  );
};
